import OpenHeader from "src/shared/components/OpenHeader";

import EmailVerificationContainer from "../containers/EmailVerification/EmailVerification";

const EmailVerification = () => (
  <>
    <OpenHeader />
    <EmailVerificationContainer />
  </>
);

export default EmailVerification;
